import { HTMLAttributes } from 'react';

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  textColor?: string;
  disabled?: boolean;
}

const Button = ({ textColor, disabled = false, className, children, onClick, ...buttonProps }: ButtonProps) => (
  <button
    {...buttonProps}
    className={`rounded-[20px] bg-primary w-[355px] h-[66px] bg-[#F2F2F2] flex justify-center items-center cursor-pointer select-none transition-colors duration-150 ease-in-out hover:opacity-95 active:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-black data-[primary=true]:bg-[#ff6060] data-[primary=true]:text-white data-[variant=secondary]:bg-[#f2f2f2] data-[variant=secondary]:text-[#262626] data-[variant=ghost]:bg-white data-[variant=ghost]:text-[#262626] data-[variant=ghost]:border data-[variant=ghost]:border-[#e5e5e5] ${
      className ?? ''
    }`}
    style={{ backgroundColor: disabled ? '#ffcccc' : undefined }}
    onClick={(e) => {
      if (!disabled) {
        onClick?.(e);
      }
    }}
  >
    <span
      className="text-[18px] leading-9 font-bold text-white data-[variant=secondary]:text-[#262626] data-[variant=ghost]:text-[#262626]"
      style={{ color: textColor }}
    >
      {children}
    </span>
  </button>
);

export default Button;
